<script setup lang="ts">
import Icon from '@/components/shared/Icon.vue'
import DropdownShell from '@/components/shared/New/Dropdown/DropdownShell.vue'
import { useProjectedSelf } from '@/composables/useProjectedSelf'
import { getAppVersion } from '@/lib'
import { DropdownMenuItem, DropdownMenuSeparator } from 'radix-vue'
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const { data: projectedSelf } = useProjectedSelf()

const selfInitials = computed(() => {
  return projectedSelf.value?.Record.DN
    .split(' ')
    .map(word => word.charAt(0).toUpperCase())
    .join('')
    .substring(0, 2)
})

const appVersion = getAppVersion()

function handleViewProfile() {
  router.push(`/detail/${projectedSelf?.value?.Record.Id}`)
}

function handleSignOut() {
  window.location.href = '/Account/LogOff'
}
</script>

<template>
  <DropdownShell v-if="projectedSelf?.Record.DN" align="end" side="bottom">
    <template #trigger>
      <div class="inline-flex gap-x-3 items-center antialiased rounded-full cursor-pointer shrink-0 text-start focus:outline-none">
        <div class="shrink-0 size-[38px] rounded-full bg-primary-500 flex items-center justify-center">
          <span class="text-[15px] font-semibold text-white">
            {{ selfInitials }}
          </span>
        </div>
      </div>
    </template>

    <div class="border-b border-gray-200 dark:border-gray-700">
      <DropdownMenuItem class="flex gap-x-3 items-center px-3 py-1.5 text-sm text-gray-800 rounded-md transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800/70 default-focus" @click="handleViewProfile">
        <div class="flex justify-center items-center rounded-full shrink-0 size-8 bg-primary-500">
          <span class="font-semibold text-white">
            {{ selfInitials }}
          </span>
        </div>
        <div class="grow">
          <span class="text-sm font-semibold text-gray-800 dark:text-gray-200">{{ projectedSelf?.Record.DN }}</span>
          <p class="text-xs text-gray-500 dark:text-gray-400">
            {{ projectedSelf?.Record.Email }}
          </p>

          <p class="text-xs text-gray-500 dark:text-gray-400">
            Version: {{ appVersion }}
          </p>
        </div>
      </DropdownMenuItem>
    </div>

    <div class="pt-1">
      <DropdownMenuItem class="flex gap-x-3 items-center px-3 py-1.5 text-sm text-gray-800 rounded-md transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-900 default-focus" @click="handleViewProfile">
        <Icon variant="eye" class="shrink-0 size-[18px]" :stroke-width="1.75" />
        <span class="cursor-default">View Profile</span>
      </DropdownMenuItem>
    </div>

    <DropdownMenuSeparator class="my-1 h-px bg-gray-200 dark:bg-gray-700" />

    <div class="pb-1">
      <DropdownMenuItem class="flex gap-x-3 items-center px-3 py-1.5 text-sm text-gray-800 rounded-md transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-900 default-focus" @click="handleSignOut">
        <Icon variant="log-out" class="shrink-0 size-[18px]" :stroke-width="1.75" />
        <span class="cursor-default">Sign out</span>
      </DropdownMenuItem>
    </div>
  </DropdownShell>
</template>
